import { Paper } from "@mui/material";

const SubscriptionBundle = ({ subscription }) => {
  return <Paper>Bundle</Paper>;
};

export default SubscriptionBundle;
